import {noop} from '@sail/utils';
import {createContext} from 'react';

import type {Experiment, Flag, InnerExperiments, InnerFlags} from 'src/types';

type ForceExperiment = <TName extends Experiment>(
  name: TName,
  value: InnerExperiments[TName],
) => void;

type ForceFlag = <TName extends Flag>(
  name: TName,
  value: InnerFlags[TName],
) => void;

type DebugContext = {
  forceExperiment: ForceExperiment;
  forceFlag: ForceFlag;
};

export default createContext<DebugContext>({
  forceExperiment: noop,
  forceFlag: noop,
});
